import { handleFuneralHome } from '../caseDetails'

export const insertableFuneralHomeDetails = (editorProps) => {
  const { caseDetails } = editorProps
  if (!caseDetails) return

  const funeralHomeIdExists = editorProps?.funeralHomeDetails?.id
  if (!funeralHomeIdExists) {
    console.warn(
      'No funeral home ID found - cannot insert funeral home details',
    )
    return
  }

  const insertableFuneralHomeDetails = []

  handleFuneralHome(
    editorProps.editor,
    editorProps.funeralHomeDetails,
    insertableFuneralHomeDetails,
    editorProps.dateFormat,
    editorProps.selectedTheme,
  )
  return insertableFuneralHomeDetails
}

export default insertableFuneralHomeDetails
